const LAUNCH_TYPE = process.env.REACT_APP_LAUNCH_TYPE || "SERVER";
const isDevelopment = process.env.NODE_ENV === 'development';

let staticPath, apiUrl, democracyUrl, dozorUrl;

if (LAUNCH_TYPE === "LOCAL") {
    staticPath = "http://localhost";
    apiUrl = "http://localhost:8080";
    democracyUrl = "http://localhost:3001";
    dozorUrl = "http://localhost:3002";
} else if(LAUNCH_TYPE === "DEV"){
    staticPath = "https://api.solbaumanec.ru";
    apiUrl = "http://localhost:8080";
    democracyUrl = "http://localhost:3002";
    dozorUrl = "http://localhost:3003";
} else {
    staticPath = "https://api.solbaumanec.ru";
    // В development используем proxy (пустой URL = same origin)
    // В production используем полный URL
    apiUrl = "https://api.solbaumanec.ru";
    democracyUrl = "https://democracy1.solbaumanec.ru";
    dozorUrl = "https://dozor.solbaumanec.ru";
}

export const CAMP_CODE = "SOLBAUMANEC";

export { staticPath, apiUrl, democracyUrl, dozorUrl };